import { TagIcon } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useOptionalSeller } from '~/hooks/data/use-seller'
import { useShop } from '~/hooks/data/use-shop'
import type { ShopPromotions as ShopPromotionsType } from '~/schemas/shop'
import { Dialog, Tag } from '~/ui'
import { getPromotionLabel } from '~/utils/promotion'

import { PromotionsForm } from './promotions-form'

export const ShopPromotions = () => {
  const { t } = useTranslation()
  const seller = useOptionalSeller()
  const shop = useShop()
  const promotions = (shop.promotions as ShopPromotionsType) || []

  const [isOpen, setIsOpen] = useState(false)

  if (!seller) {
    return promotions.map((promotion, index) => {
      const label = getPromotionLabel(promotion, t)
      if (!label) return null

      return (
        <Tag key={index}>
          <Tag.Icon>
            <TagIcon />
          </Tag.Icon>
          {label}
        </Tag>
      )
    })
  }

  return (
    <>
      {/* Trigger */}
      {promotions.length ? (
        <>
          {promotions.map((promotion, index) => {
            const label = getPromotionLabel(promotion, t)
            if (!label) return null

            return (
              <Tag key={index} onClick={() => setIsOpen(true)} interactive>
                <Tag.Icon>
                  <TagIcon />
                </Tag.Icon>

                {label}
              </Tag>
            )
          })}
        </>
      ) : (
        <Tag
          role="button"
          tabIndex={0}
          onClick={() => setIsOpen(true)}
          interactive
        >
          <Tag.Icon>
            <TagIcon className="opacity-64" />
          </Tag.Icon>
          {t(`components.manage_discounts.manage_discounts`)}
        </Tag>
      )}

      {/* Form */}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <Dialog.Content>
          <Dialog.Title>
            {t('components.manage_discounts.manage_discounts')}
          </Dialog.Title>
          <PromotionsForm onSuccessfulSubmit={() => setIsOpen(false)} />
        </Dialog.Content>
      </Dialog>
    </>
  )
}
